<template>
    <div class="all">
        <!-- 会员导航 -->
        <vipMenu></vipMenu>
        <div class="warp mt20">
            <div class="warp-body clearfix">
                <h3 class="color-red" v-if="memberRights.tips != ''">{{memberRights.tips}}</h3>
                <!-- 建方案 -->
                <div class="form-warp mt20 input-list field fl">
					<div class="item clearfix">
					    <span class="name fl namewidth">用户账号:</span>
					    <div class="input-father">
					        <span class="input-tips">{{memberRights.username}}</span>
					    </div>
					</div>
					<div class="item clearfix">
					    <span class="name fl namewidth">手机号码:</span>
					    <div class="input-father">
					        <span class="input-tips">{{memberRights.tel}}</span>
					    </div>
					</div>
                    <div class="item clearfix">
                        <span class="name fl namewidth">到期时间:</span>
                        <div class="input-father">
                            <span class="input-tips">{{memberRights.endDate}}</span>
                        </div>
                    </div>
                    <div class="item clearfix" v-if="userInfo.isLeader">
                        <span class="name fl namewidth">主体词-分析词数:</span>
                        <div class="input-father">
                            <!-- <span class="input-tips">总数{{memberRights.totalKeyWords}}个，已用{{memberRights.useKeyWords}}个</span> -->
                            <span class="input-tips">已用{{memberRights.useKeyWords}}个</span>
                        </div>
                    </div>
                    <div class="item clearfix" v-if="userInfo.isLeader">
                        <span class="name fl namewidth">方案数:</span>
                        <div class="input-father">
                            <!-- <span class="input-tips">总数{{memberRights.schemeNum}}个，已用{{memberRights.useSchemeNum}}个</span> -->
                            <span class="input-tips">已用{{memberRights.useSchemeNum}}个</span>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl namewidth">单次导出量:</span>
                        <div class="input-father">
                            <span class="input-tips">{{memberRights.downloadNum}}条</span>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl namewidth">剩余导出量:</span>
                        <div class="input-father">
                            <span class="input-tips">{{memberRights.downloadSurplus}}条</span>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl namewidth">事件传播分析:</span>
                        <div class="input-father">
                            <span class="input-tips">已用{{memberRights.eventCount}}个，剩余{{memberRights.eventSurplus}}个</span>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl namewidth">剩余评论采集量:</span>
                        <div class="input-father">
                            <span class="input-tips">{{memberRights.remainCollectionNum}}条</span>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl namewidth">剩余互动量:</span>
                        <div class="input-father">
                            <span class="input-tips">{{memberRights.remainRefreshNum}}条</span>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl namewidth">剩余短信数:</span>
                        <div class="input-father">
                            <span class="input-tips">{{memberRights.remainSmsNum}}条</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
import vipMenu from './vipMenu.vue';
import {mapState} from 'vuex';
export default {
    components:{vipMenu},
    computed:{
        ...mapState({
            userInfo: state => state.user.userInfo,
        })
    },
    data() {
        return {
            vipIcons:[
                {'icon':'','bg':'vip-rank2'},
                {'icon':'rank-icon4','bg':'vip-rank4'},
                {'icon':'rank-icon1','bg':'vip-rank1'},
                {'icon':'rank-icon3','bg':'vip-rank3'},
                {'icon':'rank-icon5','bg':'vip-rank5'}
            ],//会员等级对照表
            memberTypeName:'',//会员名称
            remainDays:'',//会员剩余天数
            memberType:'',//会员等级
            memberRights:''//会员权限
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.getPageInformation();
        })
    },
    created() {

    },
    methods: {
        // 获取页面信息
        getPageInformation () {
            let that = this;
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('user/member/member-rights',null,r =>{
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    let data = r.data;
                    // that.memberTypeName = data.memberGradeName;
                    // that.memberType = data.memberGrade;
                    // let memberRights = [];
                    // for(let i=0,len=data.memberRights.length;i<len;i+=3){
                    //     memberRights.push(data.memberRights.slice(i,i+3));
                    // }
                    // that.remainDays = data.remainDays;
                    that.memberRights = data;
                });
            })
        },
		// 会员购买
        renesJump () {
            if(this.memberType === 0){
                this.$router.push({ path:'/vipBuy'})
            }else{
                this.$router.push({ path:'/renew',query:{memberType:this.memberType,form:'renew'}})
            }
        },
		// 短信购买
        duanXinJump () {
            this.$router.push({ path:'/duanXinRecharge'})
        },
		// 下载量购买
        downloadJump () {
            this.$router.push({ path:'/downloadBuy'})
        },
        // destroyed() {
        //     let id = JSON.parse(sessionStorage.getItem('planStorage')).id;
        //     if(!this.userInfo.isAdmin&&id==''){
        //         this.$router.push({ path:'/vipRight'});
        //     }
        // }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/personalCenter/vipRight.vue